export default __webpack_public_path__ + "static/media/34t.feaf57ec.jpg";